import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid align-items-end mb-1" }
const _hoisted_3 = { class: "field col-4" }
const _hoisted_4 = { class: "block mb-1" }
const _hoisted_5 = { class: "p-input-icon-left w-100pc" }
const _hoisted_6 = {
  key: 1,
  class: "field col-4"
}
const _hoisted_7 = {
  key: 2,
  class: "field col-4"
}
const _hoisted_8 = { class: "p-input-icon-left w-100pc" }
const _hoisted_9 = { class: "field col-4" }
const _hoisted_10 = { class: "field col-4" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-wrap align-items-center gap-4 mb-3"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "flex ml-2 mr-2",
  style: {"position":"relative","width":"40px","height":"40px"}
}
const _hoisted_14 = {
  key: 1,
  class: "flex justify-content-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "mb-3" }, "Reports", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.selectedReport,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedReport) = $event)),
          options: _ctx.reports,
          optionLabel: "label",
          placeholder: "Select a report...",
          class: "w-100pc",
          onChange: _ctx.onReportChange
        }, {
          value: _withCtx(({ value, placeholder }) => [
            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "pi pi-chart-line mr-2" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(value ? value.label : placeholder), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "options", "onChange"])
      ]),
      (_ctx.selectedReport)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.selectedReport.fields.includes(_ctx.ReportField.Search))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(['field', _ctx.firstRowIsSearchFilterOnly ? 'col-8' : 'col-4'])
                }, [
                  _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.selectedReport.searchLabel || 'Search'), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.selectedReport.searchIcon || 'pi pi-home')
                    }, null, 2),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.filters.search,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.search) = $event)),
                      placeholder: "Keyword filter...",
                      class: "w-100pc"
                    }, null, 8, ["modelValue"])
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.selectedReport.fields.includes(_ctx.ReportField.Service))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block mb-1" }, "Service", -1)),
                  _createVNode(_component_Dropdown, {
                    modelValue: _ctx.filters.selectedService,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.selectedService) = $event)),
                    options: _ctx.servicesList,
                    optionLabel: "serviceName",
                    placeholder: "Select service...",
                    filter: !_ctx.selectedReport.serviceDisabled,
                    disabled: _ctx.selectedReport.serviceDisabled,
                    filterPlaceholder: "Find a service",
                    class: "w-100pc"
                  }, {
                    value: _withCtx(({ value, placeholder }) => [
                      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "pi pi-fw pi-bookmark mr-2" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(value ? value.serviceName : placeholder), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "filter", "disabled"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedReport.fields.includes(_ctx.ReportField.City))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block mb-1" }, "Location", -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "pi pi-globe" }, null, -1)),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.filters.city,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.city) = $event)),
                      placeholder: "Location...",
                      class: "w-100pc"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedReport.fields.includes(_ctx.ReportField.Dates))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", null, null, -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block mb-1" }, "Start Date", -1)),
                    _createVNode(_component_Calendar, {
                      modelValue: _ctx.filters.startDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.startDate) = $event)),
                      dateFormat: "dd/mm/yy",
                      showIcon: true,
                      class: "w-100pc",
                      placeholder: "Start date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-1" }, "End Date", -1)),
                    _createVNode(_component_Calendar, {
                      modelValue: _ctx.filters.endDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.endDate) = $event)),
                      dateFormat: "dd/mm/yy",
                      showIcon: true,
                      class: "w-100pc",
                      placeholder: "End date"
                    }, null, 8, ["modelValue"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.selectedReport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleToggleFilters, (toggle) => {
            return (_openBlock(), _createElementBlock("div", {
              key: toggle.key,
              class: "flex align-items-center gap-2"
            }, [
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.filters[toggle.key],
                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[toggle.key]) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createElementVNode("a", {
                onClick: ($event: any) => (_ctx.filters[toggle.key] = !_ctx.filters[toggle.key])
              }, _toDisplayString(toggle.label), 9, _hoisted_12)
            ]))
          }), 128)),
          (_ctx.selectedReport.island)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _withDirectives(_createElementVNode("a", {
                  class: _normalizeClass(['css-image', _ctx.filters.filterNorthIsland ? 'north-island-icon' : 'north-island-disabled-icon']),
                  style: {"position":"absolute","margin-top":"-2px","height":"20px","width":"30px"},
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.filters.filterNorthIsland = !_ctx.filters.filterNorthIsland; _ctx.filters.filterSouthIsland = false;})
                }, null, 2), [
                  [
                    _directive_tooltip,
                    'North Island',
                    void 0,
                    { top: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("a", {
                  class: _normalizeClass(['css-image', _ctx.filters.filterSouthIsland ? 'south-island-icon' : 'south-island-disabled-icon']),
                  style: {"position":"absolute","margin-top":"18px","height":"20px","width":"30px"},
                  onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.filters.filterSouthIsland = !_ctx.filters.filterSouthIsland; _ctx.filters.filterNorthIsland = false;})
                }, null, 2), [
                  [
                    _directive_tooltip,
                    'South Island',
                    void 0,
                    { top: true }
                  ]
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedReport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_Button, {
            label: "Export to Excel",
            icon: "pi pi-file-excel",
            loading: _ctx.isExporting,
            onClick: _ctx.exportReport
          }, null, 8, ["loading", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}